module.exports = __webpack_public_path__ + "img/GetBoarded_Logo2.152559e0.svg";